/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_New_PasswordInputs */

const en_common_new_password = /** @type {(inputs: Common_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Password`)
};

const es_common_new_password = /** @type {(inputs: Common_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva contraseña`)
};

/**
* | output |
* | --- |
* | "New Password" |
*
* @param {Common_New_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_new_password = /** @type {((inputs?: Common_New_PasswordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_New_PasswordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_new_password(inputs)
	return en_common_new_password(inputs)
});